import handleQueryError from '../../../util/Common/Error/Handler/handleQueryError';
import commonDefaultAPI from '../api';

const getSafetyTruck = async () => {
  try {
    const response = await commonDefaultAPI.get(`safetytruck`);
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default getSafetyTruck;
